import React, { useState } from "react";
import Modal from "react-modal";
import UserService from "../../services/UserService";
import Button from "../Button/Button";
import Input from "../Input/Input";
import "./DeleteButton.css";
import { useAuth } from "../../contexts/auth";
import { MdDelete } from "react-icons/md";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--containerBackgroundColor)",
	},
};

function DeleteButton({ disabled = false, ...props }) {
	const [modalIsOpen, setIsOpen] = React.useState(false);
	const [password, setPassword] = useState("");
	const { user } = useAuth();

	function afterOpenModal() { }

	async function handleConfirm() {
		if (props.askForPassword) {
			const response = await UserService.login(user.userData.email, password);
			if (response.data.token) {
				setIsOpen(false);
				props.handleDelete();
				return;
			}
		} else {
			setIsOpen(false);
			props.handleDelete();
		}
	}

	function handleCancel() {
		setIsOpen(false);
	}

	return (
		<React.Fragment>
			{props.simple ? (
				<button type="button" onClick={() => setIsOpen(true)} disabled={disabled} className={`cursor-pointer hover:text-red-400 duration-100`}>
					<MdDelete size={18} />
				</button>
			) : (
				<Button
					className={"button-red " + props.className}
					label={"Remover"}
					onClick={() => setIsOpen(true)}
					action="delete"
					disabled={disabled}
				></Button>
			)}
			{modalIsOpen && (
				<Modal
					isOpen={modalIsOpen}
					onAfterOpen={afterOpenModal}
					onRequestClose={handleCancel}
					style={customStyles}
					contentLabel="Modal"
					ariaHideApp={false}
				>
					<div className="modal-content-container">
						<h1 className="modal-text">Tem certeza que deseja excluir?</h1>
						{props.askForPassword && (
							<React.Fragment>
								<p className="delete-button-modal-text">
									Esta é uma operação que não pode ser desfeita!
								</p>
								<p className="delete-button-modal-text">
									{" "}
									Os dados serão PERMANENTEMENTE excluídos!
								</p>
								<p className="delete-button-modal-text">
									Para continuar, confirme suas credenciais:
								</p>
								<Input
									name="password"
									id="password"
									placeholder="Digite sua senha"
									value={password}
									type="password"
									autoComplete="off"
									onChange={({ target }) => setPassword(target.value)}
									required={true}
								/>
							</React.Fragment>
						)}
						<div className="modal-buttons-container">
							<Button onClick={handleConfirm} label="Sim"></Button>
							<Button
								className={"button-white"}
								onClick={handleCancel}
								label="Cancelar"
							></Button>
						</div>
					</div>
				</Modal>
			)}
		</React.Fragment>
	);
}
export default DeleteButton;
